import { DealersAndLocationsDropdownKeys } from "components/DealersAndLocationsDropdown/queryKeys";
import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { DealersDashboardQueryKeys } from "modules/DealersDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { DealerLocation } from "models";

export const useDeleteLocationMutation = () =>
  useTypedMutation<DealerLocation, void>({
    mutationFn: async ({ id }) => {
      await ApiInstance.post("/locations/delete", { id }, ENV.dealerBaseURL);
    },
    onSuccess: deletedLocation => {
      const dealers = typedQueryClient.getQueryData(DealersDashboardQueryKeys.list);
      const listDealerIdx = dealers?.findIndex(dealer => dealer.id === deletedLocation.dealer_id) ?? -1;

      if (dealers && listDealerIdx !== -1) {
        const listDealer = dealers[listDealerIdx];
        const listLocationIdx = listDealer.locations?.findIndex(location => location.id === deletedLocation.id) ?? -1;

        if (listLocationIdx !== -1)
          typedQueryClient.setQueryData(
            DealersDashboardQueryKeys.list,
            dealers.with(listDealerIdx, { ...listDealer, locations: listDealer.locations?.toSpliced(listLocationIdx, 1) })
          );
      }

      const dealersList = typedQueryClient.getQueryData(DealersAndLocationsDropdownKeys.dealers);
      const dealerIdx = dealersList?.dealers.findIndex(dealer => dealer.id === deletedLocation.dealer_id) ?? -1;
      if (!dealersList || dealerIdx === -1) return;

      const dealer = dealersList.dealers[dealerIdx];
      const locationIdx = dealer.locations?.findIndex(location => location.id === deletedLocation.id) ?? -1;
      if (locationIdx === -1) return;

      typedQueryClient.setQueryData(DealersAndLocationsDropdownKeys.dealers, {
        ...dealersList,
        dealers: dealersList.dealers.with(dealerIdx, { ...dealer, locations: dealer.locations?.toSpliced(locationIdx, 1) })
      });
    }
  });
